import React from "react";
import './NotFoundRoute.css'
export default function NotFoundRoute() {
    return (
      <section>
        <h2 className="notfound">404 - Page not found</h2>
        <p className="centered">Try going back to your previous page.</p>
      </section>
    );
}

